import React, { useState, useEffect, useRef } from "react";
import { MSG } from "../constants/toastMessages";
import { toast } from 'react-toastify';
import { IoCloseOutline } from "react-icons/io5";
import { apiCallingPost } from "../api/services";
import RegexPattern from "../utils/regexPattern";
import Select from 'react-select';
import { BiDownArrowAlt } from "react-icons/bi";
import { MdKeyboardArrowDown } from "react-icons/md";
import { PhoneNumberUtil } from 'google-libphonenumber';
import CreatableSelect from "react-select/creatable";
const phoneUtil = PhoneNumberUtil.getInstance();

function AdminAdd(props) {
  const [name, setName] = useState("");
  const [mobilenumber, setMobilenumber] = useState("");
  const [emailId, setemailId] = useState("");
  const [password, setPassword] = useState("");
  const [saveFlag, setSaveFlag] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [showSearch, setShowSearch] = useState(false);
  const [idpUserId, setIdpUserId] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const wrapperRef = useRef(null);

  useEffect(() => {
    getCountryList();
    getCompanyList();
    if (props.mode == "Edit") {
      setName(props.selectedAdmin.display_name)
      setMobilenumber(props.selectedAdmin.mobile_number)
      setSelectedCountry(props.selectedAdmin.country_id)
      setemailId(props.selectedAdmin.email_id)
      setPassword(props.selectedAdmin.password)
      setIdpUserId(props.selectedApprover.idp_user_id)

    }
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSearch(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getCountryList = () => {
    apiCallingPost("api/common/get_country").then((data) => {
      if (data.data.success === "1") {
        const countries = data.data.result || [];
        setCountryList(countries);
        let selected = countries.find(item =>
          props?.selectedAdmin?.country_id && item.id == props.selectedAdmin.country_id
        );
        if (!selected) {
          selected = countries.find(item => item.phone_code === "+974");
        }
        if (selected) {
          setSelectedCountry(selected);
        }
      } else {
        toast.error(data.data.successMessage);
      }
    }).catch((error) => {
      toast.error(MSG.genericError);
    });
  };
  const getCompanyList = () => {
    apiCallingPost("api/common/get_all_companies").then((data) => {
      if (data.data.success === "1") {
        const companies = data.data.result.companies || [];
        const formatted = companies.map((c) => ({ value: c, label: c }));
        setCompanyList(formatted);

      } else {
        toast.error(data.data.successMessage);
      }
    }).catch((error) => {
      toast.error(MSG.genericError);
    });
  };
  const isPhoneValid = (number, country) => {
    if (!country || !number) return false;
    try {
      const fullNumber = `${country.phone_code}${number}`;
      const phoneNumber = phoneUtil.parseAndKeepRawInput(fullNumber, country.country_code);
      return phoneUtil.isValidNumber(phoneNumber);
    } catch (error) {
      return false;
    }
  };
  const adminAdd = (e) => {
    e.preventDefault();
    let flag = true;
    if (!name) {
      toast.error(MSG.nameRequired);
      document.getElementById("name").focus();
      flag = false;
      return;
    }
    if (!selectedCountry) {
      toast.error(MSG.countryRequired);
      setShowSearch(true);
      return;
    }

    if (!mobilenumber || !isPhoneValid(mobilenumber, selectedCountry)) {
      toast.error(MSG.mobileInvalid);
      document.getElementById("mobilenumber").focus();
      return;
    }
    if (!emailId || !RegexPattern.Email.test(emailId)) {
      toast.error(MSG.emailInvalid);
      document.getElementById("emailId").focus();
      flag = false;
      return;
    }
    // if (!password) {
    //   toast.error(MSG.passwordRequired);
    //   flag = false;
    //   return;
    // }

    const milliseconds = new Date().getTime();

    let url = ""
    let postData
    setSaveFlag(true)
    if (flag && props.mode === "Add") {
      postData = {
        display_name: name,
        mobile_number: mobilenumber,
        email_id: emailId,
        password: "",//password,
        created_on: milliseconds,
        role_id: 2,
        country_id: selectedCountry?.id || "",
        company: selectedCompany?.value || ""
      };
      url = "api/authentication/userSignup"
    }
    else {
      postData = {
        display_name: name,
        mobile_number: mobilenumber,
        email_id: emailId,
        updated_on: milliseconds,
        country_id: selectedCountry?.id || "",
        id: props?.selectedAdmin?.id,
        company: selectedCompany?.value || ""
      };
      url = "api/authentication/userUpdate"
    }

    apiCallingPost(url, postData).then((data) => {
      setTimeout(() => {
        setSaveFlag(false)
      }, 500);
      if (data.data.success === "1") {
        if (props.mode === "Add") {
          toast.success(MSG.adminAdded);
        }
        else {
          toast.success(MSG.adminUpdated);
        }
        // if (props.mode === "Add") {
        //   let postData = {
        //     "email": emailId,
        //     "password": "",//password,
        //     "displayName": name,
        //     "mobile_number": mobilenumber
        //   }
        //   apiCallingPost("api/authentication/create_idp_user", postData).then((data) => {

        //   }).catch((error) => {
        //     // console.log(".......error........", error);
        //     //props.cancelPopup();
        //   });
        // } else {
        // if (props.mode !== "Add" && idpUserId) {
        //   let postData = {
        //     "email": emailId,
        //     // "password": password,
        //     "displayName": name,
        //     "mobile_number": selectedCountry?.phone_code + mobilenumber,
        //     "uid": idpUserId
        //   }
        //   apiCallingPost("api/authentication/edit_idp_user", postData).then((data) => {

        //   }).catch((error) => {
        //     // console.log(".......error........", error);

        //     //props.cancelPopup();
        //   });
        // }
        setTimeout(() => {
          props.setActivePage(1)
          props.setOffset(0)
          props.cancelPopup();
          props.userListFn("", 0)
        }, 1000);
      } else {
        toast.error(data.data.errorMessage);
      }
    }).catch((error) => {
      props.cancelPopup();
    });
  }

  const customFilter = (option, inputValue) => {
    return (
      option.data.name.toLowerCase().includes(inputValue.toLowerCase()) ||
      option.data.phone_code.includes(inputValue)
    );
  };

  const handleChange = (selected) => {
    setSelectedCompany(selected);
  };

  const handleInputChange = (inputValue, { action }) => {
    if (action === "input-change") {
      // while typing, store as selected
      setSelectedCompany({ value: inputValue, label: inputValue });
    }
  };
  return (

    <div className="modal-admin-wrapper add-admin">
      <div className="modal-ad-popup modal-md">
        <div className="modal-innerpopup ">
          <div className="modal-headdiv d-flex justify-content-between">
            <h5 className="modal-head">Add Admin </h5>
            <span className="closeBtn"><IoCloseOutline size={32} onClick={() => props.cancelPopup()} /></span>
          </div>
          <div className="modal-admin-body">
            <div className="col-12">
              <div className="form_div">
                <input
                  type="text"
                  id="name"
                  placeholder="Name"
                  className="form-register-popup"
                  value={name}
                  onChange={(e) => {
                    if (/^[a-zA-Z. ]*$/.test(e.target.value))
                      setName(e.target.value)
                  }}
                />
              </div>
              <div className="form_div"
                ref={wrapperRef}
              >
                <div className=" form-relative-select">
                  <div className="select-sub-class">
                    <div onClick={() => setShowSearch(!showSearch)} >
                      {selectedCountry?.phone_code}
                      <MdKeyboardArrowDown />
                    </div>
                    {showSearch &&
                      <div className="menuIsOpen-select">
                        <Select
                          classNamePrefix="select"
                          id="countrySelect"
                          isSearchable
                          options={countryList}
                          value={selectedCountry}
                          onChange={(selectedOption) => {
                            setSelectedCountry(selectedOption);
                            setShowSearch(false);
                          }}
                          getOptionValue={(option) => option.id}
                          getOptionLabel={(option) => `${option.name}`}
                          filterOption={customFilter}
                          placeholder="Search country code..."
                          noOptionsMessage={({ inputValue }) =>
                            inputValue ? `No country codes found for "${inputValue}"` : "No country codes available"
                          }
                          menuIsOpen
                          autoFocus
                        />
                      </div>
                    }
                  </div>
                  <input
                    type="number"
                    id="mobilenumber"
                    placeholder="Mobile Number"
                    className="form-register-popup mb-0"
                    value={mobilenumber}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, ''); // Removes non-numeric characters
                      // if (value.length <= 10 || value.length <= 11) {
                      setMobilenumber(value);
                      // }
                    }}
                    inputMode="numeric"
                  />
                </div>
              </div>
              <div className="form_div">
                <input
                  type="text"
                  id="emailId"
                  placeholder="Email Id"
                  value={emailId}
                  onChange={(e) => setemailId(e.target.value)}
                  className="form-register-popup"
                />
              </div>
              {/* {props.mode == "Add" &&
                <div className="form_div">
                  <input
                    type="password"
                    id="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-register-popup"
                  />
                </div>
              } */}

              <div className="form_div mb-3">
                <CreatableSelect
                  options={companyList}
                  value={selectedCompany}
                  onChange={handleChange}
                  onInputChange={handleInputChange}
                  placeholder="Select or Type company name"
                  isClearable={false}
                  isSearchable
                  classNamePrefix="select"
                  formatCreateLabel={(inputValue) => `${inputValue}`} // custom text when typing
                />
                {/* <Select
                  options={companyList}
                  value={selectedCompany}
                  onChange={(e)=>{handleChange(e)}}
                  placeholder="Select Company name"
                  isSearchable
                  // className="form-register-popup"
                   classNamePrefix="select"
                  //  menuIsOpen = {true}
                /> */}
              </div>

              <button
                type="submit"
                disabled={saveFlag}
                className="accept-all-btn w-100 py-2"
                onClick={adminAdd}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminAdd;
